const styles = theme => ({
  root: {
    boxShadow: 'none',
    border: '1px solid #c4c4c4',
    maxWidth: 40,
    textAlign: 'center'
  }
});

export default styles;